/**
 * Sport categories (mirrors news.ts)
 */
export type SponsorSport =
  | 'cricket'
  | 'football'
  | 'basketball'
  | 'hockey'
  | 'tennis'
  | 'badminton'
  | 'athletics'
  | 'swimming'
  | 'volleyball'
  | 'kabaddi'
  | 'wrestling'
  | 'boxing'
  | 'other';

/**
 * A sponsorship story — athlete who got sponsored via AmaPlayer
 * Stored in Supabase public.sponsor_stories table
 * Featured on the app home screen carousel
 */
export interface SponsorStory {
  id: string;
  athleteName: string;
  athleteUserId?: string;
  sport: SponsorSport;
  sponsorBrand: string;
  dealDescription: string;
  coverImageUrl?: string;
  athleteImageUrl?: string;
  dealAmount?: string;
  location?: string;
  isActive: boolean;
  isFeatured: boolean;
  authorName: string;
  publishedAt?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Data structure for creating/updating a sponsor story
 */
export interface CreateSponsorStoryData {
  athleteName: string;
  athleteUserId?: string;
  sport: SponsorSport;
  sponsorBrand: string;
  dealDescription: string;
  coverImageUrl?: string;
  athleteImageUrl?: string;
  dealAmount?: string;
  location?: string;
  isFeatured?: boolean;
  publishedAt?: string;
}

/**
 * Stats for the sponsor stories dashboard card
 */
export interface SponsorStoryStats {
  total: number;
  active: number;
  featured: number;
}

export const SPONSOR_SPORT_OPTIONS: { value: SponsorSport; label: string }[] = [
  { value: 'cricket', label: 'Cricket' },
  { value: 'football', label: 'Football' },
  { value: 'basketball', label: 'Basketball' },
  { value: 'hockey', label: 'Hockey' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'badminton', label: 'Badminton' },
  { value: 'athletics', label: 'Athletics' },
  { value: 'swimming', label: 'Swimming' },
  { value: 'volleyball', label: 'Volleyball' },
  { value: 'kabaddi', label: 'Kabaddi' },
  { value: 'wrestling', label: 'Wrestling' },
  { value: 'boxing', label: 'Boxing' },
  { value: 'other', label: 'Other' },
];
